import { useEffect, useRef, useState } from 'react';

const SWARM_ENDPOINT = "wss://molt-swarm.gabethorne614.workers.dev/room";

export function useSovereignSync() {
    const socket = useRef<WebSocket | null>(null);
    const [isConnected, setIsConnected] = useState(false);
    const [lastMessage, setLastMessage] = useState<any>(null);

    useEffect(() => {
        // Connect to the Holographic Room
        socket.current = new WebSocket(SWARM_ENDPOINT);

        socket.current.onopen = () => {
            console.log("[SovereignSync] Connected to the Hive.");
            setIsConnected(true);
            // Announce presence
            socket.current?.send(JSON.stringify({ type: 'JOIN', device: 'HorizonDeck' }));
        };

        socket.current.onmessage = (event) => {
            try {
                const data = JSON.parse(event.data);
                console.log("[SovereignSync] Signal Received:", data);
                setLastMessage(data);
            } catch (e) {
                console.warn("[SovereignSync] Malformed signal:", event.data);
            }
        };

        socket.current.onclose = () => {
            console.log("[SovereignSync] Disconnected.");
            setIsConnected(false);
        };

        return () => {
            socket.current?.close();
        };
    }, []);

    // Function to broadcast state to other devices
    const broadcast = (payload: any) => {
        if (socket.current?.readyState === WebSocket.OPEN) {
            socket.current.send(JSON.stringify(payload));
        }
    };

    return { isConnected, lastMessage, broadcast };
}
